<template>
    <!--    <div id="app" @contextmenu="handleMouse">-->
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    methods: {
        handleMouse(e) {
            e.preventDefault();
        },
    }
}
</script>

<style>

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #f7f8fa;
}

body {
    margin: 0 0.2rem auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue